import React from 'react';
import PopupLink from '../PopupLink';

import { DONATE_URL } from '../../config';

const DonateButton = () => (
  <div className="donate-wrapper">
    <PopupLink href={DONATE_URL}>
      <button className="donor-button due-landing__dorito-btn">
        Donate to Due!
      </button>
    </PopupLink>
    <div className="donor-slime" />
  </div>);

export default DonateButton;
